import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Grading;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import omit from 'lodash/omit';
import url from 'url';
import debounce from 'lodash/debounce';
import { Button, IconButton } from '@instructure/ui-buttons';
import { IconXSolid } from '@instructure/ui-icons';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import NumberInput from '@instructure/quiz-number-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { Card, Page, QuizzesSpinner as Spinner } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/es/format-message';
import { Flex, GRADE_BY_QUESTION_SUBJECT, REGISTER_MESSAGE_SUBJECT, SUBMISSION_CHANGE_SUBJECT, withStyleOverrides } from '@instructure/quiz-common';
import { GradingSidebar, SessionItemResultList } from '@instructure/quiz-grading';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var Grading = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Grading = /*#__PURE__*/function (_Component) {
  function Grading(_props) {
    var _props$windowObj;
    var _this;
    _classCallCheck(this, Grading);
    _this = _callSuper(this, Grading, [_props]);
    // =============
    //   LIFECYCLE
    // =============
    _defineProperty(_this, "changeQuizSessionResponseHandler", function (messageData) {
      // submission.external_tool_url signature comes from canvas
      var externalToolUrl = messageData.submission && messageData.submission.external_tool_url;
      if (externalToolUrl) {
        var urlParams = url.parse(externalToolUrl, true) || {
          query: {}
        };
        var participantSessionId = urlParams.query.participant_session_id;
        if (participantSessionId) {
          _this.changeUser(participantSessionId);
        }
      }
    });
    _defineProperty(_this, "gradeByQuestionResponseHandler", function (messageData) {
      var enabled = messageData.enabled;
      if (_this.props.gradeByQuestionEnabled !== enabled) {
        _this.props.setGradeByQuestionEnabled(enabled);
      }
    });
    _defineProperty(_this, "windowMessageHandler", function (event) {
      var messageData = event.data;
      if (!messageData) {
        return;
      }
      switch (messageData.subject) {
        case SUBMISSION_CHANGE_SUBJECT:
          return _this.changeQuizSessionResponseHandler(messageData);
        case GRADE_BY_QUESTION_SUBJECT:
          return _this.gradeByQuestionResponseHandler(messageData);
      }
    });
    // =============
    //   CALLBACKS
    // =============
    _defineProperty(_this, "setContinueToNextStudentRef", function (ref) {
      _this.continueToNextStudentRef = ref;
    });
    _defineProperty(_this, "handleChangePoints", function (sessionItemResultKey, itemId, newPoints) {
      _this.props.sessionItemResultsModification(sessionItemResultKey, {
        itemId: itemId,
        score: newPoints,
        id: sessionItemResultKey
      });
    });
    _defineProperty(_this, "handleChangeFeedback", function (sessionItemResultKey, itemId, feedback) {
      _this.props.sessionItemResultsModification(sessionItemResultKey, {
        itemId: itemId,
        feedback: feedback,
        id: sessionItemResultKey
      });
    });
    _defineProperty(_this, "handleChangeGradeStatus", function (sessionItemResultKey, itemId, newStatus) {
      var clearCorrect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var scoredData = {
        gradeStatus: newStatus
      };
      if (clearCorrect) {
        scoredData.correct = null;
      }
      // FIXME: should this be a visible alert?
      _this.props.screenreaderNotification(t('marked as {newStatus}', {
        newStatus: newStatus
      }));
      _this.props.sessionItemResultsModification(sessionItemResultKey, {
        itemId: itemId,
        id: sessionItemResultKey,
        scoredData: scoredData
      });
    });
    _defineProperty(_this, "updateFudgePoints", debounce(function () {
      if (_this.state.normalizedFudgePoints != null) {
        var fudgePoints = parseFloat(_this.state.normalizedFudgePoints) || 0;
        _this.props.changeFudgePoints(_this.props.quizSessionResult.id, fudgePoints);
      }
    }, 250, {
      leading: true,
      trailing: true
    }));
    _defineProperty(_this, "handleChangeFudgePoints", function (event, fudgePoints, normalizedFudgePoints) {
      _this.setState({
        fudgePoints: fudgePoints,
        normalizedFudgePoints: normalizedFudgePoints
      }, _this.updateFudgePoints);
    });
    _defineProperty(_this, "handleBlurFudgePoints", function () {
      _this.updateFudgePoints.flush();
    });
    _defineProperty(_this, "handleUpdateResults", function () {
      var _this$props = _this.props,
        quizSessionId = _this$props.quizSessionId,
        postQuizSessionResults = _this$props.postQuizSessionResults,
        sessionItems = _this$props.sessionItems,
        workingQuizSessionResult = _this$props.workingQuizSessionResult,
        afterGradeUpdate = _this$props.afterGradeUpdate;
      var mods = sessionItems.map(function (sessionItem) {
        return sessionItem.sessionItemResult.getWorkingInstance();
      });
      // replace graderId at some point as well
      var alteredMods = mods.map(function (m) {
        return omit(m, 'gradingMethod');
      });
      var workingFudgePoints = workingQuizSessionResult.fudgePoints;
      return _this.withUpdatingGrade(postQuizSessionResults(quizSessionId, alteredMods, workingFudgePoints, _this.points())).then(function () {
        _this.postGradeRefresh();
        _this.props.successNotification(t('Results updated.'));
        return afterGradeUpdate(quizSessionId, _this.continueToNextStudentRef && _this.continueToNextStudentRef.checked);
      });
    });
    _defineProperty(_this, "withUpdatingGrade", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.props.updatingGrade) {
                _context.next = 2;
                break;
              }
              throw new Error('Grade update in progress');
            case 2:
              _this.props.setUpdatingGrade(true);
              _context.prev = 3;
              _context.next = 6;
              return promise;
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
              _context.prev = 7;
              _this.props.setUpdatingGrade(false);
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 7, 10]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "postGradeRefresh", function () {
      var window = _this.windowObjectFromProps;
      if (window.parent !== window) {
        window.parent.postMessage('refreshGrades', '*');
      }
    });
    _defineProperty(_this, "renderUpdateButton", function (props) {
      return jsx(Button, Object.assign({}, props, {
        disabled: _this.props.updatingGrade || !_this.props.hasResultsModifications,
        color: "primary",
        onClick: _this.handleUpdateResults,
        "data-automation": "sdk-update-grade-button"
      }), t('Update'));
    });
    _this.windowObjectFromProps = (_props$windowObj = _props.windowObj) !== null && _props$windowObj !== void 0 ? _props$windowObj : window;
    return _this;
  }
  _inherits(Grading, _Component);
  return _createClass(Grading, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.postToParent({
        subject: REGISTER_MESSAGE_SUBJECT,
        payload: {
          singleLtiLaunch: true,
          disableGradeInput: true
        }
      });
      this.fetchData();
      this.windowObjectFromProps.addEventListener('message', this.windowMessageHandler);
      this.loadFudgePoints(this.props.workingQuizSessionResult);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.loadFudgePoints(nextProps.workingQuizSessionResult);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.windowObjectFromProps.removeEventListener('message', this.windowMessageHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.quizSessionId !== this.props.quizSessionId) {
        this.fetchData();
      }
    }
  }, {
    key: "loadFudgePoints",
    value: function loadFudgePoints(workingQuizSessionResult) {
      var fudgePoints = workingQuizSessionResult.fudgePoints;
      this.setState({
        fudgePoints: Number(fudgePoints),
        normalizedFudgePoints: fudgePoints
      });
    }
  }, {
    key: "changeUser",
    value: function changeUser(participantSessionId) {
      this.props.onChangeUser(participantSessionId); // Trigger consumer provided callback
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this$props2 = this.props,
        anonymousGrading = _this$props2.anonymousGrading,
        fetchQuizSession = _this$props2.fetchQuizSession,
        quizSessionId = _this$props2.quizSessionId;
      fetchQuizSession(quizSessionId, anonymousGrading);
    }
  }, {
    key: "points",
    value: function points() {
      var quizSessionResult = this.props.quizSessionResult;
      return quizSessionResult && quizSessionResult.score;
    }
  }, {
    key: "pointsPossible",
    value: function pointsPossible() {
      var quizSessionResult = this.props.quizSessionResult;
      return quizSessionResult && quizSessionResult.pointsPossible;
    }
  }, {
    key: "renderFudgePoints",
    value:
    // =============
    //   RENDERING
    // =============

    function renderFudgePoints() {
      if (!this.props.showFudgePoints) {
        return null;
      }
      return jsx("div", {
        css: this.props.styles.fudgePointsSection
      }, jsx("div", {
        css: this.props.styles.fudgeInfo
      }, jsx("div", {
        css: this.props.styles.fudgePointsLabel
      }, t('Fudge Points')), jsx("div", null, t('Manually adjust the score by adding positive or negative points to this box'))), jsx("div", {
        className: "fs-mask",
        css: this.props.styles.fudgePointsBox
      }, jsx(NumberInput, {
        id: "fudgePointsInput",
        placeholder: "--",
        renderLabel: jsx(ScreenReaderContent, null, t('Fudge Points')),
        onChange: this.handleChangeFudgePoints,
        onBlur: this.handleBlurFudgePoints,
        value: this.state.fudgePoints,
        "data-automation": "sdk-fudge-points-numberinput",
        width: "6rem"
      })));
    }
  }, {
    key: "renderUpdateBar",
    value: function renderUpdateBar() {
      var continueToNextStudentCheckbox;
      if (this.props.showContinueToNextStudentCheckbox) {
        continueToNextStudentCheckbox = jsx("span", {
          css: this.props.styles.continueToNextStudentWrapper
        }, jsx(Checkbox, {
          inline: true,
          label: t('Continue to Next Student'),
          ref: this.setContinueToNextStudentRef,
          defaultChecked: true,
          "data-automation": "sdk-continue-to-next-student-checkbox"
        }));
      }
      return jsx("div", {
        css: this.props.styles.submitBar
      }, continueToNextStudentCheckbox, this.renderUpdateButton());
    }
  }, {
    key: "renderFinalScore",
    value: function renderFinalScore() {
      return jsx("div", {
        css: this.props.styles.finalScoreWrapper
      }, jsx("div", {
        css: this.props.styles.finalScoreLabel
      }, t('Final Score')), jsx("div", {
        className: "fs-mask",
        css: this.props.styles.finalScore,
        "data-automation": "sdk-final-score-div"
      }, t('{points, number} / {pointsPossible, number}', {
        points: this.points(),
        pointsPossible: this.pointsPossible()
      })));
    }
  }, {
    key: "renderGradeByQuestionBanner",
    value: function renderGradeByQuestionBanner() {
      if (this.props.gradeByQuestionEnabled && !this.props.gradeByQuestionBannerDismissed) {
        return jsx(View, {
          as: "div",
          background: "alert",
          width: "100%",
          padding: "0 0 0 x-small"
        }, jsx(Flex, null, jsx(Flex.Item, {
          shouldGrow: true
        }, t('Grade by question')), jsx(Flex.Item, null, jsx(IconButton, {
          withBackground: false,
          withBorder: false,
          color: "primary-inverse",
          screenReaderLabel: t('Dismiss grade by question banner'),
          onClick: this.props.dismissGradeByQuestionBanner
        }, jsx(IconXSolid, null)))));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        needToLoad = _this$props3.needToLoad,
        sessionItems = _this$props3.sessionItems,
        header = _this$props3.header;
      if (needToLoad) {
        return jsx(Card, {
          wrapped: true
        }, jsx(Spinner, null));
      }
      return jsx(Page, {
        sidebarComponent: GradingSidebar,
        sidebarOpen: this.props.sidebarOpen,
        toggleSidebar: this.props.toggleSidebar
      }, this.renderGradeByQuestionBanner(), jsx(Card, {
        wrapped: true,
        css: this.props.styles.root,
        "data-automation": "sdk-grading"
      }, header, jsx(SessionItemResultList, {
        handleChangePoints: this.handleChangePoints,
        handleChangeFeedback: this.handleChangeFeedback,
        handleChangeGradeStatus: this.handleChangeGradeStatus,
        quizSessionId: this.props.quizSessionId,
        regradingIdentifier: this.props.regradingIdentifier,
        renderUpdateButton: this.renderUpdateButton,
        sessionItems: sessionItems
      }), this.renderFudgePoints(), this.renderFinalScore(), this.renderUpdateBar()));
    }
  }]);
}(Component), _defineProperty(_Grading, "displayName", 'Grading'), _defineProperty(_Grading, "componentId", "Quizzes".concat(_Grading.displayName)), _defineProperty(_Grading, "propTypes", {
  afterGradeUpdate: PropTypes.func,
  anonymousGrading: PropTypes.bool,
  changeFudgePoints: PropTypes.func.isRequired,
  dismissGradeByQuestionBanner: PropTypes.func.isRequired,
  fetchQuizSession: PropTypes.func.isRequired,
  gradeByQuestionBannerDismissed: PropTypes.bool,
  gradeByQuestionEnabled: PropTypes.bool,
  hasResultsModifications: PropTypes.bool.isRequired,
  header: PropTypes.node,
  needToLoad: PropTypes.bool.isRequired,
  onChangeUser: PropTypes.func,
  postQuizSessionResults: PropTypes.func.isRequired,
  postToParent: PropTypes.func.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  quizSessionResult: ImmutablePropTypes.record.isRequired,
  regradingIdentifier: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  sessionItemResultsModification: PropTypes.func.isRequired,
  sessionItems: ImmutablePropTypes.list.isRequired,
  setGradeByQuestionEnabled: PropTypes.func.isRequired,
  setUpdatingGrade: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool,
  showContinueToNextStudentCheckbox: PropTypes.bool,
  showFudgePoints: PropTypes.bool,
  successNotification: PropTypes.func.isRequired,
  toggleSidebar: PropTypes.func,
  updatingGrade: PropTypes.bool,
  windowObj: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func
  }),
  workingQuizSessionResult: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _defineProperty(_Grading, "defaultProps", {
  afterGradeUpdate: function afterGradeUpdate() {},
  anonymousGrading: false,
  gradeByQuestionBannerDismissed: false,
  gradeByQuestionEnabled: null,
  header: null,
  onChangeUser: function onChangeUser() {},
  setGradeByQuestionEnabled: function setGradeByQuestionEnabled() {},
  showContinueToNextStudentCheckbox: false,
  showFudgePoints: true,
  sidebarOpen: false,
  toggleSidebar: function toggleSidebar() {},
  updatingGrade: false,
  windowObj: null
}), _Grading)) || _class);
export default Grading;